import React, { useState } from "react";
import PhoneInput from "react-phone-number-input";
import { useDispatch, useSelector } from "react-redux";
import useInputChange from "../../../utils/hooks/useInputChange";
import { useLocation } from "react-router-dom";
import {
  addIndividualCustomer,
  resetCustomerStatus,
  setApplicationInfo,
} from "../../../redux/slice/customer/customerSlice";
import { useEffect } from "react";
import { flashMessage } from "./../../../utils/flash/index";
import { isEmptyObject } from "../../../utils/validators/validators";
import Form from "../../form/Form";
import Success from "../../../pages/admin/customer/Success";
import { useRef } from "react";

const NextOfKin = ({ customerType }) => {
  const [value, setValue] = useState("");
  const { application_info, isSuccess } = useSelector(
    (state) => state.customer
  );
  const { user } = useSelector((state) => state.auth);
  const [userInput, setUserInput] = useState({
    nok_first_name: "",
    nok_middle_name: "",
    nok_last_name: "",
    nok_phone: "",
    nok_gender: "",
    nok_email: "",
    nok_address: "",
    nok_type_of_relationship: "",
    staff_id: user?.user?.staff_id,
  });
  const [error, setError] = useState({});
  const [input, handleChange] = useInputChange(
    application_info,
    setUserInput,
    error,
    setError
  );
  let successRef = useRef();

  const handlePhoneNumberChange = (phone_no) => {
    setUserInput({ ...userInput, nok_phone: phone_no });
  };

  const dispatch = useDispatch();
  const location = useLocation();

  const handleSubmit = () => {
    if (isEmptyObject(error)) {
      if (!userInput?.nok_phone) {
        flashMessage("error", "Please enter phone number");
      } else {
        // console.log(application_info, "application_info");

        dispatch(addIndividualCustomer(application_info));
        // submit data to db
      }
    }
  };

  useEffect(() => {
    dispatch(setApplicationInfo(userInput));
  }, [userInput]);

  useEffect(() => {
    if (isSuccess) {
      successRef.current.click();
    }
    dispatch(resetCustomerStatus());
  }, [isSuccess]);

  return (
    <div className="border border-top-0 px-3 py-2">
      <Form setError={setError} submitHandler={handleSubmit} values={userInput}>
        <div className="row">
          <div className="mb-0 mt-3 col-md-4">
            <label
              htmlFor="inputEmail4"
              className="form-label d-flex align-baseline"
            >
              <span>First Name</span>
              <span className="text-danger">*</span>
            </label>
            <input
              textname="first name"
              name="nok_first_name"
              onChange={handleChange}
              value={input.nok_first_name}
              type="text"
              id="nok_first_name"
              className={`form-control ${error.nok_first_name && "is-invalid"}`}
              placeholder="First Name"
            />
            {error.nok_first_name && (
              <span className="invalid-feedback">{error.nok_first_name}</span>
            )}
          </div>
          <div className="mb-0 mt-3 col-md-4">
            <label
              htmlFor="inputEmail4"
              className="form-label d-flex align-baseline"
            >
              <span>Middle Name</span>
            </label>
            <input
              textname="middle name"
              validate="false"
              name="nok_middle_name"
              onChange={handleChange}
              value={input.nok_middle_name}
              type="text"
              id="nok_middle_name"
              className={`form-control ${
                error.nok_middle_name && "is-invalid"
              }`}
              placeholder="Middle Name"
            />
          </div>
          <div className="mb-0 mt-3 col-md-4">
            <label
              htmlFor="inputEmail4"
              className="form-label d-flex align-baseline"
            >
              <span>Last Name</span>
              <span className="text-danger">*</span>
            </label>
            <input
              textname="last name"
              name="nok_last_name"
              onChange={handleChange}
              value={input.nok_last_name}
              type="text"
              id="nok_last_name"
              className={`form-control ${error.nok_last_name && "is-invalid"}`}
              placeholder="Last Name"
            />
            {error.nok_last_name && (
              <span className="invalid-feedback">{error.nok_last_name}</span>
            )}
          </div>
        </div>
        <div className="row mb-2">
          <div className="mb-0 mt-3 col-md-6">
            <label
              htmlFor="inputEmail4"
              className="form-label d-flex align-baseline"
            >
              <span>Email</span>
            </label>
            <input
              textname="email"
              name="nok_email"
              validate="false"
              onChange={handleChange}
              value={input.nok_email}
              type="text"
              id="nok_email"
              className={`form-control ${error.nok_email && "is-invalid"}`}
              placeholder="Enter Email"
            />
          </div>
          <div className="col-md-6 mt-3">
            <label htmlFor="inputEmail4" className="form-label">
              Phone Number
              <span className="text-danger">*</span>
            </label>

            <PhoneInput
              placeholder="Enter phone number"
              value={value}
              onChange={handlePhoneNumberChange}
              defaultCountry="NG"
              className="form-control custom-phone-input"
            />
          </div>

          <div className="mb-0 mt-3 col-md-6">
            <label
              htmlFor="inputEmail4"
              className="form-label d-flex align-baseline"
            >
              <span>Gender</span>
              <span className="text-danger">*</span>
            </label>
            <select
              textname="nok_gender"
              name="nok_gender"
              onChange={handleChange}
              value={input.nok_gender}
              type="text"
              id="nok_gender"
              className={`form-control ${error.nok_gender && "is-invalid"}`}
            >
              <option value="">-- select an option --</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
            {error.gender && (
              <span className="invalid-feedback">{error.gender}</span>
            )}
          </div>
          <div className="mb-0 mt-3 col-md-6">
            <label
              htmlFor="inputEmail4"
              className="form-label d-flex align-baseline"
            >
              <span>Type of Relationship </span>
              <span className="text-danger">*</span>
            </label>
            <input
              textname="Relationship"
              name="nok_type_of_relationship"
              onChange={handleChange}
              value={input.nok_type_of_relationship}
              type="text"
              id="nok_type_of_relationship"
              className={`form-control ${
                error.nok_type_of_relationship && "is-invalid"
              }`}
              placeholder="Enter Type of Relationship"
            />
            {error.nok_type_of_relationship && (
              <span className="invalid-feedback">
                {error.nok_type_of_relationship}
              </span>
            )}
          </div>
          <div className="mb-0 mt-3 col-md-12">
            <label
              htmlFor="inputEmail4"
              className="form-label d-flex align-baseline"
            >
              <span>Residential Address </span>
              <span className="text-danger">*</span>
            </label>
            <textarea
              rows={3}
              textname="address"
              name="nok_address"
              onChange={handleChange}
              value={input.nok_address}
              type="text"
              id="nok_address"
              className={`form-control ${error.nok_address && "is-invalid"}`}
              placeholder="Enter address here"
            ></textarea>
            {error.nok_address && (
              <span className="invalid-feedback">{error.nok_address}</span>
            )}
          </div>
        </div>
        <div className="d-flex justify-content-end mb-3">
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
          <a
            href="#"
            data-bs-toggle="modal"
            data-bs-target="#create_customer_step_1"
            ref={successRef}
            className="invisible"
          >
            success
          </a>
        </div>
      </Form>
      <Success modal_id="create_customer_step_1" customerType={customerType} />
    </div>
  );
};

export default NextOfKin;
